import 'css-chunksrc/client/pages/documentsPage/styles.scss';export default {
  "documentsPage": "_documentsPage_18fsw_1",
  "header": "_header_18fsw_9",
  "profileNavigation": "_profileNavigation_18fsw_21"
};